define(
  'C3.PDPSerialLotFunctionality.Skeleton.View',
  ['SCView', 'pdp_skeleton_view.tpl'],
  function(SCViewComponent, pdp_skeleton_view_tpl) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function PDPSkeletonView(options) {
      SCView.call(this);

      this.options = options || {};

      this.template = pdp_skeleton_view_tpl;

      this.fadeOut = function fadeOut() {
        var self = this;
        this.$el.addClass('skeleton-fade-out');
        setTimeout(function () { self.destroy(); }, 400); // match CSS duration
      }

    }

    // Inherit parent instance methods.
    PDPSkeletonView.prototype = Object.create(SCView.prototype);

    // Restore the constuctor.
    PDPSkeletonView.prototype.constructor = PDPSkeletonView;

    PDPSkeletonView.prototype.getContext = function() {

      return {
        
      }
    }

    // Return the AMD constructor.
    return PDPSkeletonView;
  }
);
